export const getShouldForwardProp = (propsToFilter: string[]) => (prop: string) =>
    !propsToFilter.includes(prop);
